async function addCart(config) {
  if (window.$aliyunShoppingCart) {
    return await window.$aliyunShoppingCart.add(config);
  } else {
    console.error('未加载购物车资源');
    return null;
  }
}

export { addCart };


// WEBPACK FOOTER //
// ./lib/services/services/cart.js